import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-use';
import { PageHitCountApi } from '../../../shared/Helper';

const RighteousnessDead = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const { t } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    localStorage.setItem('isHome', true);
    PageHitCountApi(pathname, 0);
  }, []);

  return (
    <>
      <div className="py-5">
        <div className=" h-90  ">
          <img src="/assets/images/seabanner.jpg" className="sm:pb-4  h-80 w-full relative" alt="" />
          <div className="absolute  top-52 w-full ">
            <h2 className={`text-white sm:text-3xl text-center flex w-full justify-center font-bold py-3 `}>
              {t('Righteousness towards the dead')}
            </h2>
          </div>
        </div>
        <section
          className={` sm:h-90 flex xl:flex-row flex-col px-10 py-1  xl:px-20 ${isActive ? 'text-left' : 'text-right'}`}
        >
          <img src={`/assets/images/1234.png`} className=" lg:max-w-screen-sm" alt="" />

          {/* <h2 className={`text-black text-4xl flex font-bold py-6  ${isActive ? 'justify-right ' : 'text-left '}`}>من نحن </h2> */}
          <div className="pt-2 xl:px-10  flex flex-col justify-center items-center align-middle xl:pb-5">
            <h4 className={`text-customgreen flex sm:text-2xl  py-3 text-justify `}>
              {isActive
                ? ` هي خدمة إنشاء مشروع خاص بالشخص المتوفي برا به , بحيث يتم ملىء نموذج الطلب وعند الموافقة يتم إرسال رابط
              المساهمة في هذا المشروع لمقدم الطلب .`
                : `This service involves creating a specific project in memory of a deceased person. The request form is filled out, and upon approval, a contribution link to the project is sent to the requester.`}{' '}
            </h4>
            <button
              type="submit"
              className="text-white mx-1 w-32 bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2.5 text-center"
            >
              <Link to={'/donorLogin'}>{t('login')}</Link>
            </button>{' '}
          </div>
        </section>
      </div>
    </>
  );
};
export default RighteousnessDead;
